'use strict';

import ReactBrowserEventEmitter from 'react/lib/ReactBrowserEventEmitter';
import ViewportMetrics from 'react/lib/ViewportMetrics';
import getUnboundedScrollPosition from 'react/lib/getUnboundedScrollPosition';

const scrollPosition = getUnboundedScrollPosition(window);

ReactBrowserEventEmitter.ensureScrollValueMonitoring();
ViewportMetrics.refreshScrollValues(scrollPosition);

function getScrollY() {
  return ViewportMetrics.currentScrollTop;
}

export default getScrollY;


/** WEBPACK FOOTER **
 ** ./utils/getScrollY.js
 **/